<template>
    <div>
        <card-header icon="fa-chart-line" title="Reports" />

        <card-body>
            <card-list>
                <navigation-list-item icon="fa-circle-dollar" title="Payment Plan Forecast"
                    @click="$openCard('forecast-report', {}, card)" />
                <!-- <navigation-list-item icon="fa-circle-dollar" title="Enrollment Report"
                    @click="$openCard('enrollment-report', {}, card)" /> -->
            </card-list>
        </card-body>

        <card-footer>

        </card-footer>
    </div>
</template>

<script>
import CardHeader from "@/TIER/components/CardHeader";
import CardBody from "@/TIER/components/CardBody";
import CardFooter from "@/TIER/components/CardFooter";
import CardList from "@/TIER/components/CardList";
import NavigationListItem from "@/TIER/components/NavigationListItem";

export default {
    components: { CardFooter, CardBody, CardHeader, CardList, NavigationListItem },
    props: ['card', 'props', 'child'],
    data: function () {
        return {};
    },
    methods: {},
    watch: {},
    mounted: function () {
    }
};
</script>

<style lang="css" scoped></style>